import { GET, DELETE } from '../request'

export const getLeadsCRM = ({ mes, centro }) =>
  GET('/api/core/marketing/feedback/list/CRM', { mes, centro })

export const getLeadList = data =>
  GET('/api/core/marketing/feedback/list', data)

export const getLeadListCentral = data =>
  GET('/api/core/marketing/feedback/list/central', data)

export const getLeadsAnalysis = filter =>
  GET('/api/core/marketing/feedback/list/analysis', filter)

export const getLeadEntrantes = ({ fecha }) =>
  GET('/api/core/marketing/feedback/list/day', { fecha })

export const deleteLead = id => DELETE('/api/core/marketing/feedback', { id })

export const deleteLastContact = id =>
  DELETE('/api/core/marketing/feedback/contacto/last', { id })
